export const CONFIG_KEYS = {
  INTENT_ANNOTATOR_VERSION: 'intentAnnotatorVersion',
  ANNOTATE_LD_CLIENT_SIDE_ID: 'annotateLdClientSideId',
};

export class AppConfig {
  static configMap = new Map();
  static setConfig(leConfig = {}) {
    Object.values(CONFIG_KEYS).forEach((key) => {
      this.configMap.set(key, leConfig[key]);
    });
  }

  static getConfigByKey(key) {
    return this.configMap.get(key);
  }
}
